import LogoLarge from "@assets/LogoLarge.svg";
import LogoMedium from "@assets/LogoMedium.svg";
import LogoSmall from "@assets/LogoSmall.svg";

export enum LogoSize {
  L = "large",
  M = "medium",
  S = "small",
}

const LogoIcons = {
  [LogoSize.L]: LogoLarge,
  [LogoSize.M]: LogoMedium,
  [LogoSize.S]: LogoSmall,
}

export const Logo = ({ size }: {
  size?: LogoSize,
}) => {
  const icon = LogoIcons[size ?? LogoSize.L];
  return (
    <img
      key={size}
      src={icon}
      alt="UNI"
    />
  );
};
